<script>
	import { navigate } from "svelte-navigator";
	import Loading from "../general/Loading.svelte";
	import { import_recipe_from_url, import_recipe_by_json } from "../tastummy";
	import Popup from "../general/Popup.svelte";
	import CopyToClipboardButton from "../general/CopyToClipboardButton.svelte";

	let gpt_prompt = `
	in all future responses I want you to give me this json format from urls I send you. Do not respond to this message just say ack
{
  "title": "Chicken Alfredo",
  "description": "A classic Italian dish",
  "source": "Grandma's Cookbook",
  "image": "https://example.com/images/chicken_alfredo.jpg",
  "tags": ["Italian", "Pasta", "Chicken"],
  "instructions": [
    {
      "step": "Boil water and cook pasta until al dente",
      "ingredients": ["Pasta"]
    },
    {
      "step": "In a separate pan, cook chicken until no longer pink",
      "ingredients": ["Chicken"]
    },
    {
      "step": "In a saucepan, melt butter and add garlic, then add cream and parmesan cheese to make the Alfredo sauce",
      "ingredients": ["Butter", "Garlic", "Cream", "Parmesan Cheese"]
    },
    {
      "step": "Combine pasta, chicken, and sauce. Serve warm.",
      "ingredients": ["Pasta", "Chicken", "Butter", "Garlic", "Cream", "Parmesan Cheese"]
    }
  ],
  "ingredients": [
    {
      "name": "Pasta",
      "raw": "1 pound of pasta",
      "aisle": "Pasta",
      "amount": 1.0,
      "unit": "pound",
      "image": "https://example.com/images/pasta.jpg"
    },
    {
      "name": "Chicken",
      "raw": "2 chicken breasts",
      "aisle": "Meat",
      "amount": 2.0,
      "unit": "pieces",
      "image": "https://example.com/images/chicken.jpg"
    },
    {
      "name": "Butter",
      "raw": "2 tablespoons of butter",
      "aisle": "Dairy",
      "amount": 2.0,
      "unit": "tablespoons",
      "image": "https://example.com/images/butter.jpg"
    },
    {
      "name": "Garlic",
      "raw": "2 cloves of garlic",
      "aisle": "Produce",
      "amount": 2.0,
      "unit": "cloves",
      "image": "https://example.com/images/garlic.jpg"
    },
    {
      "name": "Cream",
      "raw": "1 cup of cream",
      "aisle": "Dairy",
      "amount": 1.0,
      "unit": "cup",
      "image": "https://example.com/images/cream.jpg"
    },
    {
      "name": "Parmesan Cheese",
      "raw": "1/2 cup of grated parmesan cheese",
      "aisle": "Dairy",
      "amount": 0.5,
      "unit": "cup",
      "image": "https://example.com/images/parmesan.jpg"
    }
  ]
}
	`;

	let url = "";
	let error_message = "";
	let loading = false;

	let by_url_visible = false;
	let by_chatgpt_visible = false;

	let chat_area = "";

	function import_recipe_by_chat() {
		loading = true;
		// import
		import_recipe_by_json(JSON.parse(chat_area))
			.then((res) => {
				navigate(`/recipe/${res.data["id"]}/edit`);
			})
			.catch((e) => {
				error_message = e.response.data.error;
			})
			.finally(() => {
				loading = false;
			});
	}

	function import_recipe() {
		// get on the import recipe api
		loading = true;
		import_recipe_from_url(url)
			.then((res) => {
				// forward to edit recipe page
				navigate("/recipe/" + res.data["id"]);
			})
			.catch((e) => {
				// show error
				error_message = e.response.data.error;
			})
			.finally(() => {
				loading = false;
			});
	}
</script>

<div>
	{#if loading}
		<Loading />
	{:else}
		<div>
			<button on:click={() => (by_url_visible = !by_url_visible)}
				>By Url</button
			>
			<Popup bind:visible={by_url_visible}>
				Import Recipe By Entering Url:
				<input type="text" bind:value={url} /><button
					on:click={import_recipe}>Import</button
				>
			</Popup>
			<button on:click={() => (by_chatgpt_visible = !by_chatgpt_visible)}
				>ChatGPT</button
			>
			<Popup bind:visible={by_chatgpt_visible}>
				<CopyToClipboardButton copy_value={gpt_prompt}
					>Copy Prompt</CopyToClipboardButton
				>
				<button on:click={import_recipe_by_chat}>Import JSON</button>
				<textarea class="jsonbox" bind:value={chat_area} />
			</Popup>
		</div>
	{/if}
	{#if error_message}
		<p class="error">{error_message}</p>
	{/if}
</div>

<style>
	button {
		margin: 1rem;
	}
	input,
	textarea {
		background: var(--background-2);
	}
	.jsonbox {
		width: 80%;
		height: 80%;
	}
</style>
